import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d5c878"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border executions-transfer border width-100 no-margin" }
const _hoisted_2 = { class: "border-bottom d-flex flex-row align-items-center justify-content-between" }
const _hoisted_3 = { class: "width-50" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "d-flex align-items-center",
  style: {"margin":"0 5px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "margin-left-5 cursor-pointer" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "d-flex align-items-center gap-3" }
const _hoisted_10 = ["id", "checked", "disabled", "onClick"]
const _hoisted_11 = { class: "border-top d-flex align-items-center p-2" }

import { ref, computed, onBeforeMount } from "vue";
import { ElInput, ElScrollbar, ElButton } from "element-plus";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, getResolution } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExecutionsTransfer',
  props: {
    targetName: {},
    items: {},
    selectedItems: {},
    defaultExecution: {}
  },
  emits: ["update", "default-selected"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;

const emit = __emit;

const search = ref("");
const selectedList = ref([] as any[]);
const defaultExecution = ref(props.defaultExecution);

onBeforeMount(() => {
  selectedList.value = props.selectedItems.map(
    (item) => props.items.find((execution) => execution.id === item.id) || item
  );
  defaultExecution.value = props.defaultExecution;
  setDefaultExecution(defaultExecution.value);
});

const filteredItems = computed(() =>
  props.items.filter(
    (item: any) =>
      !search.value ||
      item.name.toLowerCase().includes(search.value.toLowerCase())
  )
);

function onRowClick(item: any) {
  if (defaultExecution.value === item.id) {
    return;
  }
  toggleSelection(item);
}
function setDefaultExecution(item: any) {
  if (item) {
    const previousDefault = props.items.find(
      (execution) => execution.id === defaultExecution.value
    );
    if (defaultExecution.value === item.id) {
      defaultExecution.value = null;
    } else {
      defaultExecution.value = item.id;
    }
    if (!isSelected(item)) {
      toggleSelection(item);
    }
    emit("update", selectedList.value);
    emit(
      "default-selected",
      props.items.find(
        (execution) => execution.id === defaultExecution.value
      ) || null
    );
  }
}

function isSelected(item: any) {
  return selectedList.value.some((selected) => selected.id === item.id);
}

function toggleSelection(item: any) {
  const index = selectedList.value.findIndex(
    (selected) => selected.id === item.id
  );
  if (index === -1) {
    selectedList.value.push(item);
  } else {
    selectedList.value.splice(index, 1);
  }
  emit("update", selectedList.value);
}

const selectAllButtonLabel = computed(() =>
  selectedList.value.length === filteredItems.value.length
    ? "Clear"
    : "Select All"
);

function toggleSelectAll() {
  if (selectedList.value.length === filteredItems.value.length) {
    selectedList.value = filteredItems.value.filter(
      (item) => item.id === defaultExecution.value
    );
  } else {
    selectedList.value = [...filteredItems.value];
  }
  emit("update", selectedList.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.targetName) + " ", 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(ElInput), {
          class: "mt-2 mb-2",
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          size: "small",
          placeholder: _unref(t)('Common.Search')
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _createVNode(_unref(ElScrollbar), {
      height: '23vh',
      class: "padding-0"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["mt-1 mb-1 d-flex align-items-center justify-content-between transfer-item", { 'transfer-item-selected': isSelected(item) }]),
            key: index,
            onClick: ($event: any) => (onRowClick(item))
          }, [
            _createElementVNode("div", _hoisted_5, [
              (item.type)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "logo-24",
                    src: `${_unref(ASSETS_BASE_URL)}/${item?.type.toUpperCase()}${_unref(getResolution)(
              false
            )}.png`,
                    alt: "logo"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_7, [
                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                (item.isTenantDefault)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_unref(t)("Common.TenantDefault")) + ") ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "cursor-pointer",
                id: 'executions-check-' + index,
                checked: isSelected(item),
                disabled: defaultExecution.value === item.id,
                onClick: _withModifiers(($event: any) => (toggleSelection(item)), ["stop"]),
                style: {"margin":"0 5px"}
              }, null, 8, _hoisted_10),
              _createVNode(_unref(ElButton), {
                size: "mini",
                type: defaultExecution.value === item.id ? 'success' : 'primary',
                onClick: _withModifiers(($event: any) => (setDefaultExecution(item)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(defaultExecution.value === item.id
                ? _unref(t)("Common.DefaultExecution")
                : _unref(t)("Common.SetAsDefault")), 1)
                ]),
                _: 2
              }, 1032, ["type", "onClick"])
            ])
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(ElButton), {
        size: "mini",
        onClick: toggleSelectAll
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(selectAllButtonLabel.value), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})